import { createRoot } from "react-dom/client";

import { PipelineApp } from "./pipeline-app";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("Pipeline root element is missing.");

createRoot(root).render(<PipelineApp />);
